import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setDefaultMapService } from '../../../actions/mapBehavior';
import { getDefaultMapService } from '../../../selectors/mapServices';
import { EMapService } from '../../../types/map';

export const useMapService = (): [EMapService | null, React.Dispatch<React.SetStateAction<EMapService | null>>] => {
  const dispatch = useDispatch();
  const defaultMapService = useSelector(getDefaultMapService);

  const [mapService, setMapService] = useState<EMapService | null>(defaultMapService);

  useEffect(() => {
    if (defaultMapService) {
      setMapService(defaultMapService);
      dispatch(setDefaultMapService(null));
    }
  }, [defaultMapService, dispatch]);

  return [mapService, setMapService];
};
